import { render, staticRenderFns } from "./n-content-header.vue?vue&type=template&id=39ffdad7&"
import script from "./n-content-header.vue?vue&type=script&lang=ts&"
export * from "./n-content-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports